import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    members: [],
    loginState: {
      account: '',
      department: '',
      name: '',
      auth: 0
    },
    departmentAry: [],
    mainData: {}
  },
  getters: {
    details_poster: state => {
      let obj = {};
      if (state.mainData.poster) {
        for (let i in state.mainData.poster) {
          obj[i] = state.mainData.poster[i].details;
        }
      }
      return obj;
    },
    details_card: state => {
      let obj = {};
      if (state.mainData.card) {
        for (let i in state.mainData.card) {
          obj[i] = state.mainData.card[i].details;
        }
      }
      return obj;
    },
    details_ink: state => {
      let obj = {};
      if (state.mainData.ink) {
        for (let i in state.mainData.ink) {
          obj[i] = state.mainData.ink[i].details;
        }
      }
      return obj;
    },
    details_digit: state => {
      let obj = {};
      if (state.mainData.digit) {
        for (let i in state.mainData.digit) {
          obj[i] = state.mainData.digit[i].details;
        }
      }
      return obj;
    }
  },
  mutations: {
    SET_LOGIN(state, payload) {
      state.loginState.account = payload.account;
      state.loginState.name = payload.name;
      state.loginState.department = payload.department;
      state.loginState.auth = payload.auth;
    },
    SET_DEPARTMENT(state, payload) {
      state.departmentAry = payload;
    },
    SAVE_DATA(state, payload) {
      state.mainData = payload;
    },
    SET_MEMBERS(state, payload) {
      state.members = payload;
    }
  },
  actions: {
    async LOGIN_HANDLER({
      commit
    }, payload) {
      let response = false;
      return new Promise((resolve, reject) => {
        $.ajax({
          url: './server.json',
          type: 'get',
          complete: function (output) {
            const {
              login,
              departments
            } = JSON.parse(output.responseText);
            let result = login.filter(el => {
              return (
                el.account === payload.id &&
                el.password === payload.pwd &&
                el.switch === 1
              );
            });
            if (result.length !== 0) {
              commit('SET_LOGIN', result[0]);
              commit('SET_DEPARTMENT', departments);
              commit('SET_MEMBERS', login);
              response = true;
            }
            resolve(response);
          }
        });
      });
    },
    async GET_DATA({
      commit
    }, payload) {
      $.ajax({
        url: './server.json',
        type: 'get'
      }).done(response => {
        const {
          mainData
        } = response;
        commit('SAVE_DATA', mainData);
      });
    }
  }
});